import { INVOICE_API_BASE_URL } from './../globals';
import apiProvider from './provider';
import { getAuthenticationHeaders, getErrorMessage } from './utils';
import {
  getCommentFetchAllRoute,
  getCommentCountRoute,
  getFetchTaggableUsersRoute,
  getCommentPostRoute,
  CommentApiPrefix,
} from 'src/api/routes';
import { API_BASE_URL } from 'src/globals';
import { POST } from './apiHandler';

const getBaseUrl = (commentApiPrefix: CommentApiPrefix) => {
  if (commentApiPrefix === 'invoice') {
    return INVOICE_API_BASE_URL;
  }
  return API_BASE_URL;
};

const popKeyValue = (obj, key) => {
  const val = obj[key];
  delete obj[key];
  return val;
};

export const fetchTaggableUsers = async (body, commentApiPrefix: CommentApiPrefix) => {
  const sourceObjectId = popKeyValue(body, 'sourceObjectId');

  return POST(`${getBaseUrl(commentApiPrefix)}${getFetchTaggableUsersRoute(commentApiPrefix, sourceObjectId)}`, body);
  //   const response = await apiProvider.post(
  //     `${getBaseUrl(commentApiPrefix)}${getFetchTaggableUsersRoute(commentApiPrefix, sourceObjectId)}`,
  //     body,
  //     {
  //       headers: getAuthenticationHeaders(),
  //     },
  //   );
  //   return {
  //     data: response.data.data,
  //     isSuccess: true,
  //   };
  // } catch (err) {
  //   const errorMessage = getErrorMessage(err);
  //   return {
  //     errorMessage,
  //     isSuccess: false,
  //   };
  // }
};
export const fetchAllComments = async (body, commentApiPrefix: CommentApiPrefix) => {
  const sourceObjectId = popKeyValue(body, 'sourceObjectId');
  try {
    const endpoint = `${getBaseUrl(commentApiPrefix)}${getCommentFetchAllRoute(commentApiPrefix, sourceObjectId)}`;
    const headers = getAuthenticationHeaders();
    const response = commentApiPrefix === 'invoice' ?
      await apiProvider.get(
        endpoint,
        {
          headers,
          params: body,
        }) : await apiProvider.post(
          endpoint,
          body,
          { headers },
        );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const postComment = async (body, commentApiPrefix: CommentApiPrefix) => {
  const sourceObjectId = popKeyValue(body, 'sourceObjectId');
  try {
    const response = await apiProvider.post(
      `${getBaseUrl(commentApiPrefix)}${getCommentPostRoute(commentApiPrefix, sourceObjectId)}`,
      body,
      { headers: getAuthenticationHeaders() },
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getCommentCount = async (body, commentApiPrefix: CommentApiPrefix) => {
  const sourceObjectId = popKeyValue(body, 'sourceObjectId');
  try {
    const response: any = await apiProvider.get(
      `${getBaseUrl(commentApiPrefix)}${getCommentCountRoute(commentApiPrefix, sourceObjectId)}`,
      {
        params: body,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
